// store/slices/paymentSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { subscriptionService } from '../../services/subscription.service';

export const fetchPendingPayments = createAsyncThunk(
    'payments/fetchPending',
    async () => {
        const payments = await subscriptionService.getPendingPayments();
        return payments;
    }
);

export const verifyPayment = createAsyncThunk(
    'payments/verify',
    async (paymentId) => {
        await subscriptionService.verifyPayment(paymentId);
        return paymentId;
    }
);

export const rejectPayment = createAsyncThunk(
    'payments/reject',
    async ({ paymentId, reason }) => {
        await subscriptionService.rejectPayment(paymentId, reason);
        return paymentId;
    }
);

const paymentSlice = createSlice({
    name: 'payments',
    initialState: {
        pendingPayments: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Pending Payments
            .addCase(fetchPendingPayments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPendingPayments.fulfilled, (state, action) => {
                state.loading = false;
                state.pendingPayments = action.payload;
                state.error = null;
            })
            .addCase(fetchPendingPayments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            // Verify Payment
            .addCase(verifyPayment.fulfilled, (state, action) => {
                state.pendingPayments = state.pendingPayments.filter(
                    payment => payment.id !== action.payload
                );
            })
            // Reject Payment
            .addCase(rejectPayment.fulfilled, (state, action) => {
                state.pendingPayments = state.pendingPayments.filter(
                    payment => payment.id !== action.payload
                );
            });
    }
});

export default paymentSlice.reducer;

// Selectors
export const selectPendingPayments = (state) => state.payments.pendingPayments;
export const selectPaymentsLoading = (state) => state.payments.loading;
export const selectPaymentsError = (state) => state.payments.error;